/* eslint-disable no-undef */
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import {
  StyledModal,
  NoGuests,
} from "../AttendeesModal/styles";

import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
// import { AdminCloseIcon } from "../../utils/icons";
import { Border } from "../Journeys/styles";
import { fetchApi } from "../../utils/methods";
import { toast } from "react-toastify";
import SkeletonLoder from "../common/skeletonLoder";
import { t } from "i18next";
import { CommonButtonPopup } from "../ReportsV2/styles";
import CustomRadioButtonNew from "../ContentV2/CustomRadioButtonNew";
// import { CommonButtonBorder } from "../common/commonStyles";
import Waiting from "../Waiting";
import { CustomCheckBoxButton } from "../CreateEvent/style";
import { RecognitionTickIcon } from "../../utils/icons";
import { GetWellnessChallengePreQuizDetails } from "../../redux/constants/apiConstants";
import { CustomTitle, Question, QuestionsWrapper } from "./styles";
import {SubmitWellnessChallengeQuiz } from "../../redux/constants/apiConstants";
import { CommonButtonBorder } from "../common/commonStyles";



const PreQuizModal = ({ showModal,onHide, challengeId, quizType }) => {
  const [questions, setQuestions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0); // start at 0 instead of 1
  const [selectedAnswers, setSelectedAnswers] = useState({}); // store answers by questionId
  const [loading, setLoading] = useState(false);

  const fetchQuestions = async () => {
    const challenge_id = challengeId ;
    const type = quizType;

    setIsLoading(true);
    try {
      const res = await fetchApi(
        `${GetWellnessChallengePreQuizDetails}/${challenge_id}/${type}`,
        "GET"
      );

      if (res?.status === "success") {
        setQuestions(res?.data || []);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching questions:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (showModal) {
      setActiveIndex(0);
      setSelectedAnswers({});
      fetchQuestions();
    }
  }, [showModal]);

  const handleAnswerSelect = (question, answerId) => {
    setSelectedAnswers((prev) => {
      if (question.allow_multiple_respondents) {
        // multi-select: toggle answer
        const prevAnswers = prev[question.id] || [];
        const isSelected = prevAnswers.includes(answerId);
  
        return {
          ...prev,
          [question.id]: isSelected
            ? prevAnswers.filter((id) => id !== answerId) // remove if already selected
            : [...prevAnswers, answerId], // add if not selected
        };
      } else {
        // single select
        return {
          ...prev,
          [question.id]: answerId,
        };
      }
    });
  };

  const handleNext = () => {
    if (activeIndex < questions.length - 1) {
      setActiveIndex((prev) => prev + 1);
    } else {
      // last question reached → submit flow
      submitQuiz();

    }
  };

  const handleBack = () => {
    if (activeIndex > 0) {
      setActiveIndex((prev) => prev - 1);
    }
  };



  const submitQuiz = async () => {
    setLoading(true);
    try {
      const answersPayload = Object.entries(selectedAnswers).map(
        ([questionId, answerIds]) => ({
          question_id: Number(questionId),
          answer_id: Array.isArray(answerIds) ? answerIds : [answerIds] // ensure always array
        })
      );
  
      const payload = {
        challenge_id: Number(challengeId),
        quiz_type: quizType,
        answers: answersPayload,
      };
      const res = await fetchApi(`${SubmitWellnessChallengeQuiz}`,"POST",payload);

      if (res?.status === "success") {
        setLoading(false);
        // toast.success(t(res?.data?.message));
       
        onHide();
        
        // showChallengeStartModal();
      } else {
        setLoading(false);
        toast.error(res?.data?.message || t("Failed to submit quiz"));
      }
    } catch (error) {
      setLoading(false);
      console.error("Error submitting quiz:", error);
    }
  };

  // const currentQuestionId = questions?.[activeIndex]?.id;
  // const currentAnswer = selectedAnswers[currentQuestionId];
  
  // const isDisabled =
  // !currentAnswer ||
  // (Array.isArray(currentAnswer) && currentAnswer.length === 0);
  
  
  return (
    <>
      {loading && <Waiting/>}
    
      <StyledModal
        $width={"600px"}
        $height={"516px !important"}
        show={showModal}
        // onHide={onHide}
      >
        <Modal.Header style={{ background: "white", border: "none" }}>
          <CustomTitle>
            <div className="headerContainer">
              <div  className="title">{quizType === "pre" ? "Pre-Join Quiz" :"Feedback Quiz"}</div>
              {/* <span className="closeImage">
                <div onClick={onHide}>{AdminCloseIcon()}</div>
              </span> */}
            </div>
          </CustomTitle>
        </Modal.Header>
   
        <Border
          style={{
            width: "93%",
            background: "#EFEFEF",
            margin: "4px 16px 20px 16px",
          }}
        />
   
        <Modal.Body
          style={{ overflowY: "auto", maxHeight: "420px", padding: "0px 16px" }}
        >
          {isLoading ? (
            <>
              {Array.from({ length: 4 }).map((_, index) => (
                <QuestionsWrapper key={index}>
                  <div className="answer-box">
                    <SkeletonLoder width={"250px"} height={"50px"} />
                  </div>
                </QuestionsWrapper>
              ))}
            </>
          ) : questions.length > 0 ? (
            <>
              <Question>
                Q{activeIndex + 1}. {questions?.[activeIndex]?.question}
              </Question>
   
              {questions?.[activeIndex]?.answers?.map((answer, index) => (
                <QuestionsWrapper key={index}>
                  <div className="answer-box">
                    <div className="attendeeInfo">
                      <span>{answer.answer}</span>
                    </div>
  
                    {questions?.[activeIndex]?.allow_multiple_respondents ? (
                      <CustomCheckBoxButton
                        isSelected={Array.isArray(selectedAnswers[questions[activeIndex]?.id]) && selectedAnswers[questions[activeIndex]?.id].includes(answer.id)}
                        onClick={() => handleAnswerSelect(questions?.[activeIndex], answer.id)}
                        background={"#85c0ea"}
                      >
                        {Array.isArray(selectedAnswers[questions[activeIndex]?.id]) && selectedAnswers[questions[activeIndex]?.id].includes(answer.id) && (
                          <div>{RecognitionTickIcon()}</div>
                        )}
                      </CustomCheckBoxButton>
                    ) : (
                      <CustomRadioButtonNew
                        createSurvey
                        id={`answer-${answer.id}`}
                        handler={() =>
                          handleAnswerSelect(
                            questions?.[activeIndex],
                            answer.id
                          )
                        }
                        value={answer.id}
                        isChecked={
                          selectedAnswers[questions[activeIndex]?.id] === answer.id
                        }
                        challengeCreate={true}
                      />)}
                  </div>
                </QuestionsWrapper>
              ))}
   
              {/* <div style={{ display: "flex", gap: "12px", marginTop: "20px" }}>
                {activeIndex > 0 && (
                  <CommonButtonPopup
                    height="48px"
                    width="100%"
                    onClick={handleBack}
                  >
                    {t("Back")}
                  </CommonButtonPopup>
                )}
   
                <CommonButtonPopup
                  height="48px"
                  width="100%"
                  onClick={handleNext}
                >
                  {activeIndex === questions.length - 1
                    ? t("Submit Quiz")
                    : t("Next")}
                </CommonButtonPopup>
              </div> */}
            </>
          ) : (
            <NoGuests>{t("No Data Found")}</NoGuests>
          )}
        </Modal.Body>
   
        {/* Buttons fixed at bottom */}
        <Modal.Footer style={{ borderTop: "none", display: "flex", gap: "12px",justifyContent:"center" }}>
          <div style={{ display: "flex", gap: "12px", marginTop: "20px",justifyContent:"center" }}>

            {activeIndex > 0 && (
              <CommonButtonBorder height="48px" width="200px" onClick={handleBack}>
                {t("Back")}
              </CommonButtonBorder>
            )}
         
            <CommonButtonPopup height="48px" width="200px" onClick={handleNext} disabled={!selectedAnswers?.[questions?.[activeIndex]?.id] || loading}>
              {/* {activeIndex === questions.length - 1 && quizType != 'post'  ? t("Submit") : t("Next")} */}
              Next
            </CommonButtonPopup>
          </div>
        </Modal.Footer>
      </StyledModal>
    </>
  );
};

PreQuizModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  challengeId: PropTypes.number,
  showChallengeStartModal:PropTypes.func,
  quizType:PropTypes.string,
};

export default connect(null, null)(withTranslation()(PreQuizModal));
